import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail'
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext'
import { ValList } from '@/common/val/ValList'
import { IncRuleList } from '@/gp/entities/incRule/IncRuleList'
import { IncDataSrcForm } from './IncDataSrcForm'

export const IncDataSrcDetail = () => {

  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <IncDataSrcForm /> },
    { id: 'incRuleTab', label: 'Inclusion Rules', content: <IncRuleList incDataSrcId={entityObj.id} /> },
    { id: 'valTab', label: 'Validations', content: <ValList parentEntity="INC_DATA_SRC" parentEntityObj={entityObj} /> }
  ]

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}